export default __webpack_public_path__ + "static/media/nft-placeholder.82af1062.png";